import { render, staticRenderFns } from "./fromParent.vue?vue&type=template&id=4e0bf622&scoped=true&"
import script from "./fromParent.vue?vue&type=script&lang=js&"
export * from "./fromParent.vue?vue&type=script&lang=js&"
import style0 from "./fromParent.vue?vue&type=style&index=0&id=4e0bf622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0bf622",
  null
  
)

export default component.exports